export const VAT_PLACEHOLDERS: Record<string, string> = {
  DK: "99999999",
  FI: "99999999",
  NO: "999999999MVA",
  PL: "9999999999",
  SE: "999999999901",
};
